import Vue from 'vue';
// 1.引入
import VeHistogram from 'v-charts/lib/histogram.common' // 柱状图

Vue.component(VeHistogram.name, VeHistogram) //2.注册